/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import styled from "@emotion/styled";
import { Grid, Typography as MuiTypography } from "@mui/material";
import { spacing } from "@mui/system";
import { IntegratedSystem } from "../../api/integratedsystems";

const Typography = styled(MuiTypography)(spacing);

interface DashboardHeaderProps {
  system: IntegratedSystem;
  currentUser: string;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  currentUser,
}) => {
  return (
    <Grid justifyContent="space-between" container spacing={6}>
      <Grid>
        <Typography variant="h3" gutterBottom></Typography>
        <Typography variant="subtitle1" style={{ textTransform: "capitalize" }}>
          {`Welcome back ${currentUser}! We've missed you`}
          <span role="img" aria-label="Waving Hand Sign">
            👋
          </span>
        </Typography>
      </Grid>
    </Grid>
  );
};
